// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgFile24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.6601 10.4495L11.3727 17.3287C9.81991 18.7945 7.28699 18.7945 5.73416 17.3287C4.2032 15.8835 4.2032 13.557 5.73416 12.1118L13.0216 5.2326C13.9547 4.35174 15.4829 4.35174 16.416 5.2326C17.3273 6.09282 17.3273 7.47087 16.416 8.33109L9.12101 15.21C8.80725 15.5061 8.28378 15.5061 7.97034 15.2103C7.67877 14.935 7.67877 14.5054 7.97034 14.2302L14.7023 7.88279C15.0196 7.58361 15.0322 7.08611 14.7303 6.7716C14.4285 6.45708 13.9266 6.44466 13.6093 6.74384L6.87692 13.0915C5.92877 13.9866 5.92877 15.4539 6.87659 16.3486C7.80253 17.2227 9.28851 17.2227 10.2145 16.3486L17.5095 9.46969C19.0773 7.9897 19.0773 5.57399 17.5098 4.09429C15.9642 2.63524 13.4735 2.63524 11.9278 4.09429L4.64041 10.9735C2.4532 13.0382 2.4532 16.4023 4.64041 18.467C6.80574 20.511 10.3012 20.511 12.4665 18.467L19.7539 11.5878C20.071 11.2884 20.0833 10.7909 19.7812 10.4766C19.4792 10.1623 18.9773 10.1501 18.6601 10.4495Z"
			/>
		</Svg>
	);
});
SvgFile24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgFile24;
